import { maybe } from "@saleor/misc";
import { useTableStyles } from "@saleor/remittanceRunner/styles/tableStyles";
import { RemittanceRunnerOrders_remittanceOrders_edges_node } from "@saleor/remittanceRunner/types/RemittanceRunnerOrders";
import {
  getOrderManuallyAdjustedAmount,
  isOrderManuallyAdjusted
} from "@saleor/remittanceRunner/utils/handlers";
import { currencyFormat } from "@saleor/utils/formatters/currencyFormat";
import React from "react";

interface RemittanceRunnerTblColAmountProp {
  order: RemittanceRunnerOrders_remittanceOrders_edges_node;
}

export const RemittanceRunnerTblColAmount: React.FC<RemittanceRunnerTblColAmountProp> = props => {
  const { order } = props;
  const tblClasses = useTableStyles(props);

  return (
    <div className={tblClasses.dataGroup}>
      <div className={tblClasses.dataTitle}>Amount</div>
      <div className={tblClasses.dataDisplay}>
        {maybe(() => order?.total?.gross?.amount) ? (
          <span>
            {isOrderManuallyAdjusted(order)
              ? currencyFormat(getOrderManuallyAdjustedAmount(order))
              : currencyFormat(order?.total?.gross?.amount)}
          </span>
        ) : (
          <span>-----</span>
        )}
      </div>
    </div>
  );
};

export default RemittanceRunnerTblColAmount;
